<template>
    <div :class="{ 'row full-height no-wrap overflow-hidden': compactView, 'flex-1 column full-height': !compactView }">
        <div class="column full-height" :class="{ 'flex-basis-75 no-wrap': compactView, 'flex-1': !compactView }">
            <div v-if="!compactView">
                <QitButton
                    color="secondary"
                    class="border"
                    :icon="mode === 'selected' ? 'fa-regular fa-cloud-arrow-up' : 'fa-regular fa-arrow-left'"
                    :label="mode === 'selected' ? $t('shared.Upload another photo') : $t('shared.Take new photo')"
                    @click="$emit('onRenew')"
                />
            </div>
            <div class="image-box q-my-md">
                <q-img :src="imageSrc" alt="image" :ratio="1" fit="contain" />
            </div>
        </div>
        <div class="flex">
            <div class="flex" :class="{ 'full-width row no-wrap': !compactView, 'q-pl-sm column': compactView }">
                <div v-if="compactView">
                    <div class="flex flex-grow">
                        <QitButton
                            color="secondary"
                            class="border"
                            :icon="mode === 'selected' ? 'fa-regular fa-cloud-arrow-up' : 'fa-regular fa-arrow-left'"
                            :label="
                                mode === 'selected' ? $t('shared.Upload another photo') : $t('shared.Take new photo')
                            "
                            @click="$emit('onRenew')"
                        />
                    </div>
                </div>
                <div :class="{ buttons: compactView, 'full-width row no-wrap gap-l': !compactView }">
                    <div :class="{ 'flex-basis-50': !compactView }">
                        <div>
                            <QitButton
                                @click="$emit('onCrop')"
                                icon="fa-regular fa-crop-simple"
                                color="secondary"
                                class="border full-width"
                                :label="$t('shared.Crop')"
                            />
                        </div>
                    </div>
                    <div :class="{ 'flex-basis-50': !compactView }">
                        <div>
                            <QitButton
                                class="full-width"
                                color="primary"
                                icon="fa-regular fa-magnifying-glass"
                                :label="$t('shared.Start search')"
                                @click="$emit('onSearch')"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import QitButton from "@/shared/components/buttons/qit-button.vue";
import { ImageMode } from "@/shared/part-recognition/dialog/part-recognition-dialog.vue";

defineProps<{ imageSrc: string; mode: ImageMode; compactView: boolean }>();
defineEmits<{ onRenew: []; onCrop: []; onSearch: [] }>();
</script>

<style lang="scss" scoped>
.image-box {
    background: $grey-20;
}
</style>
